<template>
  <div>
    <LeftSidebarMarkets
      :newVisibleLeft="userInteractions.newVisibleLeft"
      :hoverVariable="userInteractions.hoverVariable"
      :hoverVariableSubItem="userInteractions.hoverVariableSubItem"
      :newSelectedAnalysis="userSelections.newSelectedAnalysis"
      :newSelectedAnalysisParent="userSelections.newSelectedAnalysisParent"
      :itemsInformation="sidebarData.items"
      :isCommodity="true"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @onUserCommoditySelection="onUserCommoditySelection"
      @onUserChangeAnalysis="onUserChangeAnalysis"
      @onChangeContract="onChangeContract"
      @onChangeContractMonthYear="onChangeContractMonthYear"
      @onSelectedOperation="onSelectedOperation"
      @onExecuteOperation="onExecuteOperation"
      @onUserCurrencySelection="onUserCurrencySelection"
      @onClientFreightTariffChange="onClientFreightTariffChange"
    />
  </div>
</template>

<script>
import LeftSidebarMarkets from "../../sideBars/LeftSidebarMarkets.vue";
import { formatNumber } from "@/_core/_helpers/_parametric_tools";
import { format } from "d3";

export default {
  name: "LeftSidebarAnalyticsCom",
  components: {
    LeftSidebarMarkets
  },
  props: {
    activeElements: { required: true, default: {} },
    commodityInformation: { required: true, default: {} },
    commoditySpecs: { required: true, type: Array, default: () => [] },
    contractSelected: { required: true, default: 1 },
    conversionAvailable: { required: false, default: true },
    currencyNumber: { required: false, default: "" },
    currencySpecs: { required: true, type: Array, default: () => [] },
    listAnalysis: { required: true, type: Object, default: () => {} },
    listContracts: { required: true, type: Array, default: () => [] },
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    showLoading: { required: false, default: true },
    spot: { required: false, default: "-" },
    visibleLeft: { required: true, type: Boolean, default: false }
  },
  data() {
    return {
      userInteractions: {
        hoverVariable: "",
        hoverVariableSubItem: "",
        newVisibleLeft: false
      },
      sidebarData: {
        items: [
          {
            text: "",
            nameEvent: "",
            bdr: false,
            itemHeader: false,
            classNameIcon: "",
            bdrTransition: false
          }
        ]
      },
      userSelections: {
        newSelectedAnalysis: "commodities",
        newSelectedAnalysisParent: "",
        currencyActive: "",
        itemMappings: {
          fk_idproduct: newVal => newVal.commodity.toLowerCase(),
          name: newVal =>
            `${newVal.analysis.charAt(0).toUpperCase()}${newVal.analysis
              .slice(1)
              .toLowerCase()}`
        },
        childMappings: {
          continuous_contract: newVal => newVal.continuous,
          contract_month_year: newVal => newVal.contract,
          "": (newVal, child) =>
            child.text === "Select" ? newVal.operation : child.childSelected
        }
      }
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.userSelections.newSelectedAnalysis = this.selectedAnalysis;
    this.userSelections.newSelectedAnalysisParent = this.selectedAnalysisParent;
    Object.assign(this["userInteractions"], {
      newVisibleLeft: this.visibleLeft
    });
  },
  watch: {
    activeElements: {
      handler(newVal) {
        this.updateSidebarSelections(newVal);
      },
      deep: true
    },
    selectedAnalysis(val) {
      this.userSelections.newSelectedAnalysis = val;
    },
    selectedAnalysisParent(val) {
      this.userSelections.newSelectedAnalysisParent = val;
    },
    visibleLeft(val) {
      Object.assign(this["userInteractions"], {
        newVisibleLeft: val
      });
    },
    "sidebarData.items": {
      handler() {},
      deep: true
    },
    listAnalysis() {
      this.setItemsSideBar();
    },
    listContracts: {
      handler(newVal, oldVal) {
        const newValString = JSON.stringify(newVal);
        const oldValString = JSON.stringify(oldVal);

        // Comparar los strings
        if (newValString !== oldValString) {
          this.setItemsSideBar();
        }
      },
      deep: true
    },
    currencySpecs: {
      handler() {
        this.setCurrencyActive();
      },
      deep: true
    },
    commodityInformation() {
      this.setItemsSideBar();
    },
    currencyNumber() {
      this.setCurrencyActive();
    },
    "userInteractions.currencyActive": {
      handler() {},
      deep: true
    },
    contractSelected() {
      this.setItemsSideBar();
    },
    spotContract() {
      this.setItemsSideBar();
    },
    showLoading() {
      this.setDisabledElement("Commodities", "showLoading");
    },
    conversionAvailable() {
      this.setDisabledElement("Commodity Calculator", "conversionAvailable");
    },
    spot() {
      this.setNewSpot();
    }
  },
  computed: {
    dataInfo() {
      const commInfo = this.commodityInformation;
      return `
        <table style='border-spacing: 5px !important; border-collapse: separate; pointer-events: none;' class="table--dataInfo">
          <thead>
            <tr>
              <th colspan='2' style='text-align: center; vertical-align: middle;'><strong>${
                commInfo.commodity_name
              }</strong> ${commInfo.fk_idcurrency}/${commInfo.fk_idunit}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Type: </strong><span class="text--active">${
                commInfo.fk_idcommoditytype
              }</span></td>
              <td><strong>Source: </strong><span class="text--active">${
                commInfo.fk_idcommoditysource
              }</span></td>
            </tr>
            <tr>
              <td><strong>Contract Size: </strong><span class="text--active">
                ${formatNumber(commInfo.contract_size)} ${commInfo.fk_idunit}
                </span></td>
              <td><strong>Contract: </strong><span class="text--active">${
                this.contractSelected
              }</span></td>
            </tr>
            <tr>
              <td><strong>SPOT:</strong></td>
              <td>
                <span class="text--active">
                ${format(",.6r")(this.spot)}
                </span>
              </td>
            </tr>
          </tbody>
        </table>`;
    },
    currActive() {
      if (this.currencyNumber >= 0) {
        return this.currencySpecs[
          this.currencyNumber
        ]?.currency_name.toUpperCase();
      } else {
        return this.currencySpecs[11].currency_name.toUpperCase();
      }
    }
  },
  methods: {
    // User interactions
    updateSidebarSelections(newVal) {
      this.sidebarData.items.forEach(item => {
        // Update main item selections
        if (item.nameData in this.userSelections.itemMappings) {
          item.childSelected = this.userSelections.itemMappings[item.nameData](
            newVal
          );
          return;
        }

        this.processChildrenSelections(item, newVal);
      });
    },
    processChildrenSelections(item, newVal) {
      if (!item.children) return;

      item.children.forEach(child => {
        const mappingFunction = this.userSelections.childMappings[
          child.nameData
        ];
        if (mappingFunction) {
          child.childSelected = mappingFunction(newVal, child);
        }
      });
    },
    onHoverLeftSidebar(val) {
      Object.assign(this.userInteractions, { hoverVariable: val });
    },
    onHoverLeftSidebarSubItem(val) {
      this.userInteractions.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios(event) {
      Object.assign(this.userInteractions, { hoverVariable: "" });
      this.$emit("onLeftSidebarAnalysisScenarios", event);
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    onUserCommoditySelection({ item, nameEvent }) {
      if (nameEvent === "onUserCommoditySelection" && !item.children) {
        this.$emit("onUserCommoditySelection", { item, nameEvent });
      }
    },
    onUserChangeAnalysis({ item, nameEvent }) {
      if (nameEvent === "onUserChangeAnalysis" && !item.children) {
        this.$emit("onUserChangeAnalysis", { item, nameEvent });
      }
    },
    onChangeContract({ item, nameEvent }) {
      if (nameEvent === "onChangeContract") {
        this.$emit("onChangeContract", { item, nameEvent });
      }
    },
    onChangeContractMonthYear({ item, nameEvent }) {
      if (nameEvent === "onChangeContractMonthYear") {
        this.$emit("onChangeContractMonthYear", { item, nameEvent });
      }
    },
    onSelectedOperation({ item, nameEvent }) {
      if (nameEvent === "onSelectedOperation") {
        this.$emit("onSelectedOperation", { item, nameEvent });
      }
    },
    onExecuteOperation({ item, nameEvent }) {
      if (nameEvent === "onExecuteOperation") {
        this.$emit("onExecuteOperation", { item, nameEvent });
      }
    },
    onUserCurrencySelection({ item, nameEvent }) {
      if (nameEvent === "onUserCurrencySelection") {
        this.$emit("onUserCurrencySelection", { item, nameEvent });
      }
    },
    onClientFreightTariffChange({ item, valueInput }) {
      if (item.nameEvent === "onClientFreightTariffChange" && valueInput) {
        this.$emit("onClientFreightTariffChange", { item, valueInput });
      }
    },
    // Configuration data
    setNewSpot() {
      this.sidebarData.items.forEach(parentItem => {
        if (parentItem.text === "Commodity Information") {
          Object.assign(parentItem, { dataInfo: this.dataInfo });
        }
      });
    },
    setNewCurrencyActive() {
      this.sidebarData.items.forEach(parentItem => {
        if (parentItem.text === "Commodity Calculator") {
          parentItem.children.forEach((item, index) => {
            if (item.nameData === "currency_name") {
              this.$set(parentItem.children, index, {
                ...item,
                text: this.userInteractions.currencyActive,
                childSelected: this.userInteractions.currencyActive
              });
            }
          });
        }
      });
    },
    setDisabledElement(text, setVariable) {
      this.sidebarData.items.forEach((parentItem, i) => {
        if (parentItem.text === text) {
          this.$set(this.sidebarData.items, i, {
            ...parentItem,
            isDisabled: this[setVariable]
          });
        }
      });
    },
    setCurrencyActive() {
      if (this.currencyNumber >= 0) {
        this.$set(
          this.userInteractions,
          "currencyActive",
          this.currencySpecs[this.currencyNumber].currency_name.toUpperCase()
        );
        this.setNewCurrencyActive();
      }
    },
    setItemsSideBar() {
      this.$set(this, "sidebarData", {
        items: [
          {
            text: "Commodity Information",
            nameEvent: "infoComm",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-question-circle",
            bdrTransition: false,
            isOpen: false,
            action: "template",
            dataInfo: this.dataInfo
          },
          {
            isOpen: false
          },
          {
            text: "Commodities",
            nameEvent: "onUserCommoditySelection",
            bdr: false,
            itemHeader: false,
            classNameIcon: null,
            bdrTransition: false,
            children: this.commoditySpecs,
            icon: "CommoditiesIcon",
            nameData: "fk_idproduct",
            isOpen: false,
            childSelected: this.activeElements.commodity.toLowerCase(),
            isDisabled: this.showLoading,
            isFiltered: true,
            filteredChildren: this.commoditySpecs
          },
          {
            text: "Analysis",
            nameEvent: "onUserChangeAnalysis",
            bdr: false,
            itemHeader: false,
            classNameIcon: null,
            bdrTransition: false,
            children: this.listAnalysis,
            icon: "AnalysisIcon",
            nameData: "name",
            isOpen: false,
            childSelected: `${this.activeElements.analysis
              .slice(0, 1)
              .toUpperCase()}${this.activeElements.analysis
              .slice(1)
              .toLowerCase()}`
          },
          {
            text: "Contract",
            nameEvent: "contract",
            bdr: false,
            itemHeader: false,
            classNameIcon: null,
            bdrTransition: false,
            // radio buttons
            children: [
              {
                text: "Continuous Contract",
                nameEvent: "onChangeContract",
                nameEventParent: "contract",
                children: this.listContracts,
                isOpen: false,
                nameData: "continuous_contract",
                action: "radio button",
                childSelected: this.activeElements.continuous
              },
              {
                text: "Futures Contract",
                nameEvent: "onChangeContractMonthYear",
                nameEventParent: "contract",
                children: this.listContracts,
                isOpen: false,
                nameData: "contract_month_year",
                action: "radio button",
                childSelected: this.activeElements.contract
              }
            ],
            icon: "ContractIcon",
            isOpen: false
          },
          {
            text: "Commodity Calculator",
            nameEvent: "commCalc",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-calculator",
            bdrTransition: false,
            isStyleGrid: true,
            children: [
              {
                text: "Select",
                nameEvent: "convert",
                nameEventParent: "commCalc",
                multipleOpen: true,
                children: [
                  {
                    text: "",
                    classNameIcon: null,
                    nameEvent: "onSelectedOperation",
                    nameEventParent: "convert",
                    icon: "&#183;",
                    nameHover: "No apply",
                    id: 0
                  },
                  {
                    text: "",
                    classNameIcon: null,
                    nameEvent: "onSelectedOperation",
                    nameEventParent: "convert",
                    icon: "&#10005;",
                    nameHover: "Multiplication",
                    id: 1
                  },
                  {
                    text: "",
                    classNameIcon: null,
                    nameEvent: "onSelectedOperation",
                    nameEventParent: "convert",
                    icon: "&#8260;",
                    nameHover: "Division",
                    id: 2
                  }
                ],
                isOpen: false,
                nameData: "",
                childSelected: this.activeElements.operation,
                isStyleGrid: true
              },
              {
                text: this.currActive,
                nameEvent: "onUserCurrencySelection",
                nameEventParent: "commCalc",
                children: this.currencySpecs,
                isOpen: false,
                nameData: "currency_name",
                multipleOpen: true,
                childSelected: this.currActive,
                isFiltered: true,
                filteredChildren: this.currencySpecs,
                isStyleGrid: true
              },
              {
                text: "Freight:",
                nameEvent: "onClientFreightTariffChange",
                nameEventParent: "commCalc",
                action: "input",
                placeholder: "freight",
                isOpen: false,
                isStyleGrid: true
              },
              {
                text: "Tariff (%):",
                nameEvent: "onClientFreightTariffChange",
                nameEventParent: "commCalc",
                action: "input",
                placeholder: "tariff",
                isOpen: false,
                isStyleGrid: true
              },
              {
                text: "Apply",
                nameEvent: "onExecuteOperation",
                action: "button",
                isStyleGrid: true
              }
            ],
            isOpen: false,
            multipleOpen: true,
            isDisabled: this.conversionAvailable,
            isParent: true
          }
        ]
      });
    }
  }
};
</script>

<style>
.table--dataInfo .text--active {
  color: var(--textactive);
}
</style>
